/**
 * Level 3: all 20 book lessons in book order, plus the lettered lessons not in the book yet (extra.ts).
 */
import type { Lesson } from "../types";
import { L3_LESSON1 } from "./lesson01";
import { L3_LESSON2 } from "./lesson02";
import { L3_LESSON3 } from "./lesson03";
import { L3_LESSON4, L3_LESSON5, L3_LESSON6 } from "./lesson04to06";
import { L3_LESSON7, L3_LESSON8 } from "./lesson07to08";
import { L3_LESSON9, L3_LESSON10, L3_LESSON11, L3_LESSON12, L3_LESSON13 } from "./lesson09to13";
import { L3_LESSON14, L3_LESSON15, L3_LESSON16, L3_LESSON17, L3_LESSON18 } from "./lesson14to18";
import { L3_LESSON19, L3_LESSON20 } from "./reviews";
import { L3_LESSON7A, L3_LESSON8A, L3_LESSON9A, L3_LESSON13A, L3_LESSON15A, L3_LESSON18A } from "./extra";

export const LEVEL3: Lesson[] = [
  L3_LESSON1,
  L3_LESSON2,
  L3_LESSON3,
  L3_LESSON4,
  L3_LESSON5,
  L3_LESSON6,
  L3_LESSON7,
  L3_LESSON7A,
  L3_LESSON8,
  L3_LESSON8A,
  L3_LESSON9,
  L3_LESSON9A,
  L3_LESSON10,
  L3_LESSON11,
  L3_LESSON12,
  L3_LESSON13,
  L3_LESSON13A,
  L3_LESSON14,
  L3_LESSON15,
  L3_LESSON15A,
  L3_LESSON16,
  L3_LESSON17,
  L3_LESSON18,
  L3_LESSON18A,
  L3_LESSON19,
  L3_LESSON20,
];

export const lessonById = (id: string): Lesson | undefined => LEVEL3.find((l) => l.id === id);
